(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["little-roar-home"] && !Shopify.designMode) return;
  try {
    
function petsVariantState(variants, id, failed = false) {
  if (failed) return 'unknown';
  const variant = variants.find(item => String(item.id) === String(id));
  if (!variant || typeof variant.available !== 'boolean') return 'unknown';
  return variant.available ? 'available' : 'sold-out';
}

function petsColorState(variants, ids, failed = false) {
  const states = ids.map(id => petsVariantState(variants, id, failed));
  if (states.includes('available')) return 'available';
  return states.every(state => state === 'sold-out') ? 'sold-out' : 'unknown';
}

function petsStockPayload(payload, expectedId) {
  if (!payload || String(payload.id ?? payload.productId) !== String(expectedId) || !Array.isArray(payload.variants)) throw new Error('Invalid product availability response');
  return payload.variants.map(variant => {
    if (!variant || variant.id == null || typeof variant.available !== 'boolean') throw new Error('Invalid variant availability');
    return {id:String(variant.id), available:variant.available, ...(Number.isInteger(variant.price)&&variant.price>=0?{price:variant.price}:{})};
  });
}

function petsCartPayload(payload) {
  if (!payload || !Array.isArray(payload.items) || !/^[A-Z]{3}$/.test(payload.currency) || !Number.isInteger(payload.item_count) || !Number.isInteger(payload.total_price)) throw new Error('Invalid cart response');
  for (const item of payload.items) {
    if (!item.key || !Number.isInteger(item.quantity) || item.quantity < 1 || !Number.isInteger(item.final_line_price)) throw new Error('Invalid cart item');
  }
  return payload;
}

function createPetsCartClient(routes, request = fetch) {
  let pending = false;
  const send = async (url, body) => {
    const response = await request(url, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: {'Accept':'application/json', ...(body ? {'Content-Type':'application/json'} : {})},
      ...(body ? {body:JSON.stringify(body)} : {}), signal:AbortSignal.timeout(15000)
    });
    const data = await response.json();
    if (!response.ok) {
      const error = new Error(typeof data.description === 'string' ? data.description : 'Cart request failed');
      error.status = response.status;
      throw error;
    }
    return data;
  };
  const read = async () => petsCartPayload(await send(routes.cart + '.js'));
  const mutate = async (url, body) => {
    if (pending) throw new Error('Cart update already in progress');
    pending = true;
    try { await send(url, body); return await read(); }
    finally { pending = false; }
  };
  return {
    read,
    add: id => mutate(routes.add + '.js', {items:[{id:String(id),quantity:1}]}),
    remove: key => mutate(routes.change + '.js', {id:key,quantity:0})
  };
}

function initializePetsStore(root) {
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized='true';
  const catalog=JSON.parse(root.querySelector('[data-catalog]').textContent);
  const copy=JSON.parse(root.querySelector('[data-copy]').textContent);
  const inventory=JSON.parse(root.querySelector('[data-inventory]').textContent);
  const commerce=JSON.parse(root.querySelector('[data-commerce]')?.textContent||'null');
  const client=commerce?createPetsCartClient(commerce):null;
  let cartSnapshot=null,cartBusy=false,cartFailed=Boolean(client),currency=commerce?.currency||'USD';
  const cartMessage=root.querySelector('[data-cart-message]');
  const purchaseMessage=document.createElement('p');purchaseMessage.className='cart-message';purchaseMessage.setAttribute('role','alert');root.querySelector('.product-info').append(purchaseMessage);
  const checkout=root.querySelector('[data-checkout]');
  let stockVariants=[],stockFailed=false,checking=false,stockRequest=null;
  try { stockVariants=petsStockPayload(inventory,inventory.productId); } catch { stockFailed=true; }
  const addButtons=Array.from(root.querySelectorAll('[data-add]'));
  const originals=new Map(addButtons.map(button=>[button,Array.from(button.childNodes).map(node=>node.cloneNode(true))]));
  const status=document.createElement('p');status.className='stock-status';status.setAttribute('role','status');status.setAttribute('aria-live','polite');root.querySelector('.product-info').append(status);
  root.querySelectorAll('[data-color]:not(.hotspot)').forEach(button=>{const badge=document.createElement('small');badge.className='stock-badge';badge.textContent=copy.soldOut;badge.hidden=true;button.querySelector('span').append(badge);});
  root.querySelectorAll('[data-size]').forEach(button=>{const badge=document.createElement('small');badge.className='stock-size-badge';badge.textContent=copy.soldOut;badge.hidden=true;button.querySelector('span').append(badge);});
  let color=catalog.colors[0],size='Small',cart=[];
  const dialog=root.querySelector('dialog');
  const money=n=>new Intl.NumberFormat('en-US',{style:'currency',currency}).format(n);
  const selected=()=>{const id=color.ids[size==='Large'?1:0],live=stockVariants.find(v=>String(v.id)===String(id));return {...catalog.sizes[size],...(Number.isInteger(live?.price)?{price:live.price/100}:{}),color:color.name,size,image:color.image,id,sku:'LR-LION-'+color.code+'-'+(size==='Large'?'L':'S')};};
  const setText=(selector,value)=>root.querySelectorAll(selector).forEach(e=>e.textContent=value);
  const update=()=>{
    const v=selected();
    const stock=petsVariantState(stockVariants,v.id,stockFailed);
    root.dataset.stockState=stock;
    root.querySelectorAll('[data-color]').forEach(e=>{const on=e.dataset.color===color.name;e.classList.toggle('selected',on);e.setAttribute('aria-pressed',String(on));const c=catalog.colors.find(item=>item.name===e.dataset.color);const sold=petsColorState(stockVariants,c.ids,stockFailed)==='sold-out';e.classList.toggle('is-sold-out',sold);e.setAttribute('aria-label',c.name+(sold?' — '+copy.soldOut:''));const badge=e.querySelector('.stock-badge');if(badge)badge.hidden=!sold;});
    root.querySelectorAll('[data-size]').forEach(e=>{const on=e.dataset.size===size;e.classList.toggle('selected',on);e.setAttribute('aria-pressed',String(on));const sold=petsVariantState(stockVariants,color.ids[e.dataset.size==='Large'?1:0],stockFailed)==='sold-out';e.classList.toggle('is-sold-out',sold);e.setAttribute('aria-label',e.dataset.size+(sold?' — '+copy.soldOut:''));e.querySelector('.stock-size-badge').hidden=!sold;});
    for(const button of addButtons){const state=cartBusy?'adding':checking?'checking':stock;button.disabled=state!=='available';button.setAttribute('aria-busy',String(checking||cartBusy));if(button.dataset.stockState!==state){button.dataset.stockState=state;button.replaceChildren(...(state==='available'?originals.get(button).map(node=>node.cloneNode(true)):[document.createTextNode(state==='sold-out'?copy.soldOut:state==='checking'?copy.checking:state==='adding'?copy.updating:copy.unavailable)]));}}
    status.textContent=stock==='sold-out'?copy.soldOutMessage:stock==='unknown'?copy.stockError:'';status.hidden=!status.textContent;
    const img=root.querySelector('[data-product-image]'); img.src=v.image;img.alt=v.color+' '+copy.product;
    setText('[data-selected-summary]',v.color+' · '+size);setText('[data-price]',money(v.price)+' '+currency);setText('[data-button-price]',money(v.price));setText('[data-currency]',currency);setText('[data-color-label]',v.color);setText('[data-capacity]',v.limit);setText('[data-sku]',v.sku);setText('[data-dimensions]',v.dimensions);setText('[data-weight]',v.weight);root.querySelector('[data-variant-id]').value=v.id;
  };
  const refreshStock=()=>{
    if(!inventory.url)return Promise.resolve(!stockFailed);
    if(stockRequest)return stockRequest;
    checking=true;update();
    stockRequest=(async()=>{try{const url=new URL(inventory.url+'.js',document.baseURI);const response=await fetch(url.href,{cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(10000)});if(!response.ok)throw new Error('Stock request failed');stockVariants=petsStockPayload(await response.json(),inventory.productId);stockFailed=false;return true;}catch{stockFailed=true;return false;}finally{checking=false;stockRequest=null;if(root.isConnected)update();}})();
    return stockRequest;
  };
  const renderCart=()=>{
    const list=root.querySelector('[data-cart-items]');list.replaceChildren();
    const items=client?(cartSnapshot?.items||[]):cart;
    for(const item of items){
      const row=document.createElement('article');row.className='cart-row';
      const img=document.createElement('img');const knownColor=catalog.colors.find(c=>c.ids.some(id=>String(id)===String(item.variant_id)));img.src=client?(knownColor?.image||item.image||''):item.image;img.alt=client?item.product_title:item.color;img.width=95;img.height=95;
      const frame=document.createElement('div');frame.className='cart-image';frame.append(img);
      const body=document.createElement('div');
      for(const [tag,text] of [['strong',client?(item.variant_title||item.product_title):item.color+' · '+item.size],['small',(item.sku||'')+' × '+item.quantity],['span',money(client?item.final_line_price/100:item.price*item.quantity)]]){const el=document.createElement(tag);el.textContent=text;body.append(el);}
      const remove=document.createElement('button');remove.type='button';remove.textContent=copy.remove;remove.disabled=cartBusy;remove.addEventListener('click',async()=>{if(client){if(cartBusy)return;await changeCart(()=>client.remove(item.key));}else{cart=cart.filter(x=>x.id!==item.id);renderCart();}});body.append(remove);row.append(frame,body);list.append(row);
    }
    root.querySelector('[data-cart-empty]').hidden=items.length>0||Boolean(client&&(cartBusy||cartFailed));
    setText('[data-cart-count]',client?(cartSnapshot?.item_count||0):cart.reduce((n,x)=>n+x.quantity,0));setText('[data-cart-total]',client&&!cartSnapshot?'—':money(client?cartSnapshot.total_price/100:cart.reduce((n,x)=>n+x.price*x.quantity,0))+' '+currency);
    if(checkout)checkout.disabled=!client||cartBusy||cartFailed||!cartSnapshot?.item_count;
  };
  const setCartMessage=text=>{if(cartMessage)cartMessage.textContent=text;};
  const acceptCart=data=>{cartSnapshot=data;currency=data.currency;cartFailed=false;renderCart();update();};
  const syncCart=async()=>{try{acceptCart(await client.read());return true;}catch{cartFailed=true;setCartMessage(copy.cartLoadError);renderCart();return false;}};
  const changeCart=async operation=>{
    cartBusy=true;purchaseMessage.textContent='';setCartMessage(copy.updating);update();renderCart();
    try{acceptCart(await operation());setCartMessage('');return true;}
    catch(error){await syncCart();const message=error.status===422?copy.cartStockError:copy.cartUpdateError;setCartMessage(message);purchaseMessage.textContent=message;await refreshStock();return false;}
    finally{cartBusy=false;update();renderCart();}
  };
  root.querySelectorAll('[data-color]').forEach(e=>e.addEventListener('click',()=>{color=catalog.colors.find(c=>c.name===e.dataset.color);update();}));
  root.querySelectorAll('[data-size]').forEach(e=>e.addEventListener('click',()=>{size=e.dataset.size;update();}));
  root.querySelectorAll('[data-add]').forEach(e=>e.addEventListener('click',async()=>{if(cartBusy||checking||petsVariantState(stockVariants,selected().id,stockFailed)!=='available')return;const intentId=selected().id;if(!await refreshStock())return;const v=selected();if(v.id!==intentId||petsVariantState(stockVariants,v.id,stockFailed)!=='available')return;if(client){if(!dialog.open)dialog.showModal();await changeCart(()=>client.add(v.id));}else{const found=cart.find(x=>x.id===v.id);if(found)found.quantity++;else cart.push({...v,quantity:1});renderCart();dialog.showModal();}}));
  root.querySelector('[data-open-cart]').addEventListener('click',async()=>{if(!dialog.open)dialog.showModal();if(client&&!cartBusy){cartBusy=true;setCartMessage(copy.updating);renderCart();update();if(await syncCart())setCartMessage('');cartBusy=false;renderCart();update();}});
  root.querySelector('[data-close-cart]').addEventListener('click',()=>dialog.close());
  root.querySelectorAll('.shop-menu a').forEach(e=>e.addEventListener('click',()=>root.querySelector('.shop-menu').open=false));
  update();renderCart();
  if(client){
    syncCart();
    root.querySelector('[data-checkout-form]').addEventListener('submit',async event=>{event.preventDefault();if(cartBusy)return;cartBusy=true;renderCart();update();setCartMessage(copy.updating);const ok=await syncCart();cartBusy=false;renderCart();update();if(ok&&cartSnapshot.item_count>0){HTMLFormElement.prototype.submit.call(event.target);}else if(ok){setCartMessage(copy.emptyCart);}});
  }
  if(inventory.url){
    const controller=new AbortController();
    const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);controller.abort();return;}if(document.visibilityState==='visible')refreshStock();},30000);
    window.addEventListener('focus',()=>{if(root.isConnected)refreshStock();},{signal:controller.signal});
    document.addEventListener('visibilitychange',()=>{if(root.isConnected&&document.visibilityState==='visible')refreshStock();},{signal:controller.signal});
    refreshStock();
  }
}
document.querySelectorAll('.pets-store').forEach(initializePetsStore);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.pets-store').forEach(initializePetsStore));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
